module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"copyCloudAccount.finish.title":"Finish","copyCloudAccount.finish.caption":"Finally what would you like to call the shared cloud connection.","copyCloudAccount.finish.name.label":"Shared cloud connection name"}}')
  delete Component.options._Ctor
}
